import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { Dotdotdot } from '@design-system/dotdotdot';
import { useI18n } from '@design-system/i18n';
import { Cover } from './Cover';
import { GroupAndContentType } from './GroupAndContentType';
import { LinkWrapper } from './LinkWrapper';
const DEFAULT_DISPLAY_FIELDS = {
    content: false,
    contentType: false,
    date: false,
    group: false,
};
export const NewsPresentation = ({ contentTypeName, data: { content, date, group, image, title }, displayFields = DEFAULT_DISPLAY_FIELDS, onClick, path, withLink, }) => {
    const { __ } = useI18n();
    return (_jsxs(Box, { flexDirection: { _: 'column', m: 'row' }, width: "100%", children: [_jsx(ImageWrapper, { children: _jsx(Cover, { fallbackIconName: "newspaper", imageSrc: image, onClick: onClick, path: path, withLink: withLink }) }), _jsxs(Box, { alignSelf: { m: 'center' }, flexDirection: "column", ml: { m: 4 }, children: [((displayFields.group && group) || displayFields.contentType) && (_jsx(GroupAndContentType, { group: displayFields.group ? group : undefined, type: displayFields.contentType
                            ? contentTypeName !== null && contentTypeName !== void 0 ? contentTypeName : __('News')
                            : undefined })), _jsx(Box, { font: "h4-semibold", mb: 1, children: _jsx(LinkWrapper, { font: "h4-semibold", onClick: onClick, path: path, withLink: withLink, children: _jsx(Dotdotdot, { clamp: content ? 1 : 2, children: title }) }) }), content && displayFields.content && (_jsx(ContentWrapper, { "$withMargin": Boolean(displayFields.date && date), children: _jsx(Dotdotdot, { clamp: 2, screenReaderMaxLength: 300, children: content }) })), displayFields.date && date && _jsx(Box, { children: date })] })] }));
};
const ContentWrapper = styled(Box).attrs(({ $withMargin, theme }) => ({
    mb: $withMargin ? 1 : 0,
    lineHeight: theme.lineHeights[3],
})) ``;
const ImageWrapper = styled(Box).attrs(() => ({
    height: '70px',
    width: '186px',
    mb: { _: 4, m: 0 },
})) `
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
  overflow: hidden;
  flex-shrink: 0;
`;
//# sourceMappingURL=NewsPresentation.js.map